import React, { useState } from "react";
import styled from "styled-components";
import { FieldsContainer, Link, Pill } from "../../constants/assets/containers";
import { FieldHolder } from "../../constants/assets/DriverDetailsContainers";
import QcBasicDetailFields from "../../constants/QcDetails/QcBasicDetailFields.json";
import { getPath } from "../../utils";
import DriverDocumentModal from "../Common/DriverDocumentModal";
import moment from "moment";
const QcDriverBasicDetails = ({ details = {}, onboardingFlow }) => {
  const [modalContent, setModalContent] = useState("");
  const [showModal, setShowModal] = useState("");

  const handleClose = () => {
    setShowModal(false);
  };

  const handleDocClick = (file) => {
    setModalContent(file);
    setShowModal(true);
  };

  const getRequiredFlag = (field) => {
    return getPath(details, field.valuePath, "")["required"];
  };

  const getValue = (field) => {
    if (field.key === "driver_photo") {
      return (
        <Link
          onClick={() =>
            handleDocClick(
              getPath(details, field.valuePath, "")[field.valueKey]
            )
          }
        >
          {getPath(details, "basic_details.driver_photo.file_name", "") ||
            "View"}
        </Link>
      );
    }
    return getPath(details, field.valuePath, "")[field.valueKey];
  };

  const getVerifiedValue = (field) => {
    const isVerified = getPath(details, field.valuePath, "")["verified"];
    if (isVerified === true || isVerified === false) {
      return (
        <Pill isFalse={!isVerified}>
          {isVerified ? "ACCEPTED" : "REJECTED"}
        </Pill>
      );
    }

    return "PENDING";
  };

  return [
    <QcBasicDetailsContainer>
      <FieldsContainer>
        {getPath(Object.keys(details), "length", 0) > 0 &&
          Object.keys(details.basic_details).map((field, index) => {
            if (
              QcBasicDetailFields[field] &&
              getRequiredFlag(QcBasicDetailFields[field])
            ) {
              return (
                <FieldHolder data-testid="qcbasicDetailField" key={field}>
                  <span className="row-heading">
                    {QcBasicDetailFields[field].heading}
                  </span>
                  <p className="row-text field-val">
                    {getValue(QcBasicDetailFields[field])}
                  </p>
                  <p className="row-text verified-pill">
                    {getVerifiedValue(QcBasicDetailFields[field])}
                  </p>
                </FieldHolder>
              );
            }
          })}
      </FieldsContainer>
    </QcBasicDetailsContainer>,
    <DriverDocumentModal
      showModal={showModal}
      handleClose={handleClose}
      modalContent={modalContent}
    />,
  ];
};

const QcBasicDetailsContainer = styled.div`
  .row-heading {
    flex: 0 1 20%;
  }
  .field-val {
    flex: 0 1 40%;
  }
  .verified-pill {
    flex: 0 1 20%;
  }
`;

export default QcDriverBasicDetails;
